
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directory/[param]",
      function () {
        return require("private-next-pages/directory/[param].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/directory/[param]"])
      });
    }
  